// extracted by mini-css-extract-plugin
export default {"circle":"ExternalBadge_circle__8zGuE","text":"ExternalBadge_text__GuLxS"};